export const HexToRgba = (hex, opacity) => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result 
        ? 'rgba(' + [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)].join(',') + ',' + (opacity || 1) + ')'
        : null
}

//ساخت رنگ روشن -> rgb
export const BrightColorConstruction = (hex, value) => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result 
        ? 'rgb(' + [parseInt(result[1], 16) + value, parseInt(result[2], 16) + value, parseInt(result[3], 16) + value].join(',') + ')'
        : null
}

//ساخت رنگ تیره -> rgb
export const DarkColorConstruction = (hex, value) => {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result 
        ? 'rgb(' + [parseInt(result[1], 16) - value, parseInt(result[2], 16) - value, parseInt(result[3], 16) - value].join(',') + ')'
        : null
}